import { Collection, Token } from './types';

/**
 * https://www.figma.com/file/ulUeUVSNgLMAYaeH0nJxCI/Den---Foundations?type=design&node-id=849-18977&mode=design&t=tZCslkWS49FsAr7k-4
 */
export const radius = new Collection({
  none: new Token('0px', 'radius-none'),
  sm: new Token('4px', 'radius-sm'),
  md: new Token('8px', 'radius-md'),
  lg: new Token('12px', 'radius-lg'),
  xl: new Token('16px', 'radius-xl'),
  '2xl': new Token('24px', 'radius-2xl'),
  '3xl': new Token('32px', 'radius-3xl'),
  full: new Token('9999px', 'radius-full'),
});
